import styled from 'styled-components';

export const EmojiPanel = styled.div`
  position: absolute;
  top: ${({theme}) => theme.getSize(10)};
  right: ${({theme}) => theme.getSize(1)};
  width: ${({theme}) => theme.getSize(56)};
  padding: ${({theme}) => theme.getSize(2)};
  border: 1px solid ${({theme}) => theme.colors.palettes.neutral[50][100]};
  border-radius: ${({theme}) => theme.getSize(1)};
  background-color: ${({theme}) => theme.colors.palettes.white[10][100]};
  box-shadow: ${({theme}) => theme.shadows.active};
  z-index: 10;
`;

export const EmojiCategoryTabs = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({theme}) => theme.getSize(1)};
  padding-bottom: ${({theme}) => theme.getSize(2)};
`;

export type EmojiCategoryButtonProps = {
  $isActive: boolean;
};

export const EmojiCategoryButton = styled.button<EmojiCategoryButtonProps>`
  border: 1px solid;
  border-color: ${({theme, $isActive}) =>
    $isActive ? theme.colors.general.accent : theme.colors.palettes.neutral[50][100]};
  border-radius: ${({theme}) => theme.getSize(1)};
  background-color: ${({theme, $isActive}) =>
    $isActive ? theme.colors.palettes.blue[20][100] : theme.colors.palettes.white[10][100]};
  padding: ${({theme}) => `${theme.getSize(1)} ${theme.getSize(2)}`};
  font-size: ${({theme}) => theme.fontSizes.text.xSmall};
`;

export const EmojiGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: ${({theme}) => theme.getSize(1)};
`;

export const EmojiButton = styled.button`
  border: 1px solid ${({theme}) => theme.colors.palettes.neutral[40][100]};
  border-radius: ${({theme}) => theme.getSize(1)};
  background-color: ${({theme}) => theme.colors.palettes.white[10][100]};
  padding: ${({theme}) => theme.getSize(1)};
  font-size: ${({theme}) => theme.fontSizes.text.base};
`;
